import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css"; // This import is crucial
import "./i18n"; // initialize i18n (registers detector + resources)
import App from "./App";

// (LiveKit WebRTC error-suppression shims were removed with the LiveKit
// teardown on 2026-07-04 — Daily handles its own connection lifecycle.)

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
